import { Box, Button, Paper, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { sharedStyles } from '../../utils/Style';
import { DiscountAtCheckoutTabs } from './DiscountAtCheckoutTabs';
import { Settings } from '../../interfaces/Settings/Settings';
import { getSettingsByType, upsertSettings } from '../../api/Settings';
import { SettingsType } from '../../interfaces/Settings/SettingsType';
import { GenericSettingsValue } from '../../interfaces/Settings/GenericSettingsValue';
import { getSettingsValue, getUpdatedSettings } from '../../utils/Settings';
import { Waiting } from '../../components/Waiting/Waiting';
import { SettingsRow } from '../../components/Settings/SettingsRow';
import { SettingsValueType } from '../../interfaces/Settings/SettingsValueType';

const settingsKeys = [
  'at_checkout_discount_text',
  'at_checkout_discount_spend_limit',
];

export const DiscountAtCheckoutSettingsPage = () => {
  const [settings, setSettings] = useState<Settings[]>([]);
  const [loading, setLoading] = useState(true);

  const refreshSettings = () => {
    setLoading(true);
    getSettingsByType(SettingsType.AT_CHECKOUT_DISCOUNT)
      .then((s) => setSettings(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  const handleChange = useCallback(
    (key: string, newValue: GenericSettingsValue) =>
      setSettings(
        getUpdatedSettings(
          SettingsType.AT_CHECKOUT_DISCOUNT,
          key,
          settings,
          newValue,
        ),
      ),
    [settings],
  );

  const handleSave = () => {
    setLoading(true);
    upsertSettings(settings.filter((s) => settingsKeys.includes(s.key)))
      .then(() => {
        toast.success('Ayarlar başarıyla kaydedildi');
        refreshSettings();
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Waiting open={loading} />

      <DiscountAtCheckoutTabs selectedTab='settings' />

      <Box
        sx={{
          p: 3,
          width: '100%',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
          Kasa Önü İndirimi Ayarları
        </Typography>

        <Paper
          sx={{
            p: 1.5,
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            boxSizing: 'border-box',
            width: '100%',
            minWidth: 350,
            maxWidth: 600,
          }}
        >
          <SettingsRow
            name='İndirim Başlığı'
            localized
            valueType={SettingsValueType.TEXT}
            value={getSettingsValue(settings, 'at_checkout_discount_text')}
            onChange={(newValue) =>
              handleChange('at_checkout_discount_text', newValue)
            }
          />
          <SettingsRow
            name='Minimum Tutar'
            valueType={SettingsValueType.NUMBER}
            value={getSettingsValue(
              settings,
              'at_checkout_discount_spend_limit',
            )}
            onChange={(newValue) =>
              handleChange('at_checkout_discount_spend_limit', newValue)
            }
            minValue={0}
          />

          <Box display='flex' justifyContent='flex-end'>
            <Button
              variant='contained'
              onClick={handleSave}
              sx={{ ...sharedStyles.buttonText, mt: 1.5 }}
            >
              Kaydet
            </Button>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};
